import { DropdownMenuSize } from './dropdown-menu.types'

export const DEFAULT_DROPDOWN_MENU_OFFSET = 4

export const TRIGGER_SIZE_MAP: Record<DropdownMenuSize, string> = {
  medium: '3.2rem',
  small: '2.4rem',
}

export const TRIGGER_ICON_SIZE_MAP: Record<DropdownMenuSize, string> = {
  medium: '2rem',
  small: '1.6rem',
}
